var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "300px",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient--obeennvwd-1",
    x1: 150,
    x2: 150,
    y2: 300,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3b34d4",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1da7cd",
    offset: 1
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path--obeennvwd-2",
    cx: 150,
    cy: 150,
    r: 150
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter--obeennvwd-4",
    x: -0.12024,
    y: -0.11903,
    width: 1.2405,
    height: 1.2959
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 7,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0.145098039  0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient--obeennvwd-5",
    x1: 74.369,
    x2: 74.369,
    y1: 0.04254,
    y2: 148.78,
    gradientTransform: "scale(.80516 1.242)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4B3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDCC2",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "path--obeennvwd-6",
    d: "m87 139.78v0.43126c0.11854 9.118 7.7852 15.974 23 20.569-18.333 13.333-36.667 24-55 24s-36.667-10.667-55-24c15.112-4.5992 22.777-11.465 22.995-20.597-0.0044744-1.628-0.012072-3.9396-0.022793-8.2809-0.0017022-0.68929-0.0034832-1.3955-0.0053429-2.1177-1.0929 0.15445-1.0039 0.055916-5.723e-4 -0.2218-0.029524-11.419-0.078553-26.774-0.14709-42.379-14.332-18.577-9.0673-40.356-4.5757-39.813 5.5106 0.66636 53.214-44.601 62.364-46.917 9.1501-2.3162 32.393 5.1672 36.393 26.042 4 20.875 5.672 73.493-9.5 94.5-4.3174 5.978-11.117 8.3162-20.397 7.0145-0.01255 4.3688-0.03878 6.8207-0.10262 11.769z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient--obeennvwd-8",
    x1: 65.473,
    x2: 65.473,
    y1: 130.8,
    y2: 0.41815,
    gradientTransform: "scale(1.0777 .92791)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ec7437",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ef8752",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient--obeennvwd-9",
    x1: 77.965,
    x2: 77.965,
    y1: 155.93,
    gradientTransform: "scale(1.5392 .6497)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26703c",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25aa4a",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "path--obeennvwd-10",
    d: "m225 37.308c6.3468 12.905 11.347 34.238 15 64h-240c3.6549-29.765 8.6549-51.099 15-64 6.3451-12.901 28.045-25.335 65.099-37.301 10.713 21.998 69.508 21.996 79.772-0.0067589 37.073 11.967 58.782 24.403 65.129 37.308z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask--obeennvwd-3",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path--obeennvwd-2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask--obeennvwd-11",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path--obeennvwd-10"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "url(#linearGradient--obeennvwd-1)",
    fillRule: "nonzero",
    xlinkHref: "#path--obeennvwd-2"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask--obeennvwd-3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,205,49)",
    filter: "url(#filter--obeennvwd-4)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask--obeennvwd-7",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path--obeennvwd-6"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "url(#linearGradient--obeennvwd-5)",
    xlinkHref: "#path--obeennvwd-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87 128c-14.667-1.6667-26.667-5.6667-36-12 10.093 13.411 22.093 21.411 36 24z",
    fill: "#ffbe94",
    fillRule: "nonzero",
    mask: "url(#mask--obeennvwd-7)"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1,0,0,1,210,33)",
    d: "m20.5 103.5c-6.8898-16.57-34.5-50.317-10.701-71.317 8-39 52.201-34.683 81.701-25.683 19.827 6.0489 34.799 18 38 9 20 16.683 9.9844 33-3.2012 37.683-11.966 4.2504-32.202 8.5-66.606 4.5-6.1459-0.71456-4.8588 18.108-8.1432 20.143-4.9266 3.0529-8.7512-16.143-22.259-10.379-13.508 5.7638-5.4924 32.49 9.0076 32.49 5 0 7.5 13.747-6 20.247-9.7988 4.8166-7.322-5.9165-11.799-16.683z",
    fill: "url(#linearGradient--obeennvwd-8)",
    filter: "url(#filter--obeennvwd-4)"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(30,203)",
    fill: "url(#linearGradient--obeennvwd-9)",
    fillRule: "evenodd",
    xlinkHref: "#path--obeennvwd-10"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(30,203)",
    d: "m-10 33h260v8h-260zm0 20h260v8h-260zm0 20h260v8h-260z",
    fill: "#086692",
    fillRule: "evenodd",
    mask: "url(#mask--obeennvwd-11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.c7fe23c54feba79c3dc7df566940787f.svg";
export { ForwardRef as ReactComponent };